import React, { useMemo } from 'react';

import './chart-axis.scss';

interface ChartAxisProps {
  hideTickLabels?: boolean;
  increment: number;
  max: number;
  min: number;
  shouldTuckTickLabels?: boolean;
  tickSuffix?: string;
}

function ChartAxis(props: ChartAxisProps) {
  const {
    hideTickLabels = false,
    increment = 0,
    max = 0,
    min = 0,
    shouldTuckTickLabels = false,
    tickSuffix = ''
  } = props;

  const ticks = useMemo(() => {
    const ticks: Array<number> = [];
    if (increment === 0) {
      ticks.push(min, max);
    } else {
      let tick = min;
      while (tick <= max) {
        ticks.push(tick);
        tick += increment;
      }
    }
    return ticks;
  }, [increment, max, min]);

  return (
    <div
      style={{
        marginBottom: hideTickLabels ? '5px' : void 0
      }}
      styleName="container"
    >
      {ticks.map(tick => {
        let justifyContent;

        if (shouldTuckTickLabels) {
          if (tick >= max) {
            justifyContent = 'right';
          } else if (tick <= min) {
            justifyContent = 'left';
          }
        }

        return (
          <span
            key={`tick-${tick}`}
            style={{
              justifyContent
            }}
            styleName="tick"
          >
            {!hideTickLabels && (
              <span styleName="tick-marker">
                {tick}
                {tickSuffix}
              </span>
            )}
          </span>
        );
      })}
    </div>
  );
}

export default ChartAxis;
